import React, { useState } from 'react'

const BASE_COLOR = 'var(--gray100)'
const OVER_COLOR = 'var(--gray300)'

const ADD_ICON = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="18" height="18" rx="9" fill="#006FF9" />
    <path d="M10 8V5L8 5L8 8H5V10H8L8 13H10V10H13V8H10Z" fill="white" />
  </svg>
)
const CHECK_ICON = (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="18" height="18" rx="9" fill="#78D911" />
    <path d="M5 8.56757L7.57143 11L13 6" stroke="white" strokeWidth="2" />
  </svg>
)

interface Props {
  className?: string
  label: string
  isActive: boolean
  onClick: () => void
}

export const FilterButton: React.FC<Props> = ({ className = '', label, isActive, onClick }) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      className={`br-pill f6 pv1 ph2 mb2 mr2 pointer user-select-none ${className}`}
      style={{
        backgroundColor: isHovered ? OVER_COLOR : BASE_COLOR,
      }}
      onClick={() => onClick()}
      onPointerEnter={() => setIsHovered(true)}
      onPointerLeave={() => setIsHovered(false)}
    >
      <div className="flex flex-center">
        <div className={`mr1`}>{label}</div>
        <div className="flex flex-center">{isActive ? CHECK_ICON : ADD_ICON}</div>
      </div>
    </div>
  )
}
